import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSLabelText } from "@web-monorepo/dds";
import { getImageSrc } from "@web-monorepo/static-assets";
import styles from "./Discuss.module.css";

const blueDiscussCloud = getImageSrc("toolkit/src/pods/ideas/assets/blueDiscussCloud.svg");

type DiscussProps = {
  topic: string;
  onClick: VoidFunction;
};

export default function Discuss({ topic, onClick }: DiscussProps) {
  return (
    <button type="button" data-name="discuss:card" className={styles.card} onClick={onClick}>
      <div className={styles.cardContent}>
        <DDSBodyText level="md" variant="tertiary" className={styles.topic}>
          {topic}
        </DDSBodyText>
        <div className={styles.iconRow}>
          <img className={styles.icon} src={blueDiscussCloud} alt={t`Discuss`} />
          <DDSLabelText level="md" variant="accent">
            <Trans>Think Pair Share</Trans>
          </DDSLabelText>
        </div>
      </div>
    </button>
  );
}
